import { StoreI18n } from '../../Types/StoreTypes';

export const SET_I18N = 'SET_I18N';
export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';

export function setI18n(i18n: StoreI18n['i18n']) {
    return { type: SET_I18N, payload: i18n };
}

export function setSelectedLanguage(language: StoreI18n['selectedLanguage']) {
    return { type: SET_SELECTED_LANGUAGE, payload: language };
}
